import React, { useState, useEffect } from "react";
import { useQuery, useQueryClient } from "react-query";
import Table from "../../../components/tables/Table";
import EntityExpandedRow from "./EntityExpandedRow";
import SelectInput from "../../../components/SelectInput";
import TextInput from "../../../components/TextInput";
import { toast } from "../../../components/toastNotification";
import { getLicenseType, getStates } from "../../../actions/Utilities/Common";
import ButtonForModal from "../../../components/ButtonForModal";
import {
  PencilSquareIcon,
  CheckCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";
import { EyeIcon } from "@heroicons/react/24/solid";
import { updateEntity } from "../../../actions/Utilities/Entity";
import HideButton from "../../../components/HideButton";
import ConfirmBoxModal from "../../../components/ConfirmBoxModal";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../PermissionsConstants";
import { accountAtom } from "../../Login/atoms/AccountAtom";

const EntityTable = ({
  EntityData,
  selectedRows,
  handleBulkDelete,
  setOpenModal,
  setIsBulkSelected,
  handleSelectedRowsChange,
  rowIsExpanded,
  clearSelectedRows,
  updateEntityList,
  isLoading,
}) => {
  const queryClient = useQueryClient();
  const [, setState] = useState([]);
  const [states, setStates] = useState([]);
  const [checkState, setCheckState] = useState([]);
  const [licensetype, setlicensetype] = useState([]);
  const [licensetypes, setlicensetypes] = useState([]);
  const [dRLP1licensetype, setDRLP1licensetype] = useState([]);
  const [entitydataForEdit, setentitydataForEdit] = useState([]);
  const [edit, setEdit] = useState(false);
  const [show, setShow] = useState(false);
  const [entityExist, setEntityExist] = useState(false);
  const [changed, setChanged] = useState(false);
  const [, setLoading] = useState(true);
  const [openModal, setopenModal] = useState(false);
  const [hasEntity, setHasEntity] = useState(true);
  const editPermission = PERMISSIONS.permission_utilities_entity_edit;
  const deletePermission = PERMISSIONS.permission_utilities_entity_delete;
  const userPermissions = useRecoilValue(permissionsSelector);
  const userAccount = useRecoilValue(accountAtom);
  const [expirationDate, setExpirationDate] = useState("");
  const [drlExpDate, setDRLExpDate] = useState("");
  const [drlp1Value, setdrlp1Value] = useState("");
  const [dRLP1LicenseType, setDRLP1LicenseType] = useState("");
  const [notes, setNotes] = useState("");
  const [comments, setComments] = useState("");
  const [drlplicenseNumber, setDrlp1licenseNumber] = useState("");
  const [disregardedForTax, setDisregardedForTax] = useState("");

  const [editState, setEditState] = useState(false);

  const EntityEditRow = {
    EntityName: "",
    EntityEIN: "",
    LicenseNumber: "",
    StateID: 0,
    LicenseTypeID: 0,
    DRLP1: "",
    DRLP1LicenseType: "",
    DRLP1ExpDate: "",
    DRLP1LicenseNumber: "",
    DisregardedForTax: "",
    Comments: "",
    ExpirationDate: "",
    Notes: "",
    createdBy: "",
    createdOn: null,
    updatedBy: "",
    updatedOn: null,
    isActive: false,
    StateCode: "",
    usedInMexico: false,
  };
  const [entityData] = useState([EntityEditRow]);
  // edit handling
  const handleCheckBox = (checked) => {
    setChanged(true);
    checked
      ? (entityData[0].isActive = true)
      : (entityData[0].isActive = false);
    checked ? setCheckState(true) : setCheckState(false);
  };

  useQuery("States", getStates, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setStates(
        res.map((data) => {
          return { label: data.state, value: data.stateId };
        })
      );
    },
  });

  useQuery("LicenseTypes", getLicenseType, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setlicensetypes(
        res.map((license) => {
          return {
            label: license.licenseTypeName,
            value: license.licenseTypeId,
          };
        })
      );
    },
  });

  useEffect(() => {
    let timer = setTimeout(() => setLoading(false), 120000);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  //Function for Contact Table Select Input
  const handleEditEntity = (
    processname,
    fieldName,
    selectedValue,
    selectedLabel
  ) => {
    setEntityExist(false);
    setChanged(true);

    if (processname === "EditEntity") {
      var rowIndex = 0;

      if (fieldName === "EntityName") {
        entityData[rowIndex].EntityName = selectedValue?.trim();
      }

      if (fieldName === "EntityEIN") {
        entityData[rowIndex].EntityEIN = selectedValue?.trim();
      }

      if (fieldName === "LicenseNumber") {
        entityData[rowIndex].LicenseNumber = selectedValue?.trim();
      }

      if (fieldName === "StateId") {
        entityData[rowIndex].StateID = selectedValue;
        entityData[rowIndex].StateCode = selectedLabel;
      }

      if (fieldName === "LicenseTypeID") {
        entityData[rowIndex].LicenseTypeID = selectedValue;
      }

      if (fieldName === "DRLP1") {
        entityData[rowIndex].DRLP1 = selectedValue?.trim();
        setdrlp1Value(selectedValue?.trim());
      }
      if (fieldName === "DRLP1LicenseType") {
        entityData[rowIndex].DRLP1LicenseType = selectedValue.toString();
      }
      if (fieldName === "DRLP1ExpDate") {
        entityData[rowIndex].DRLP1ExpDate = selectedValue;
        setDRLExpDate(selectedValue);
      }

      if (fieldName === "DRLP1LicenseNumber") {
        entityData[rowIndex].DRLP1LicenseNumber = selectedValue?.trim();
        setDrlp1licenseNumber(selectedValue?.trim());
      }
      if (fieldName === "DisregardedForTax") {
        entityData[rowIndex].DisregardedForTax = selectedValue?.trim();
        setDisregardedForTax(selectedValue?.trim());
      }
      if (fieldName === "Comments") {
        entityData[rowIndex].Comments = selectedValue?.trim();
        setComments(selectedValue?.trim());
      }

      if (fieldName === "ExpirationDate") {
        entityData[rowIndex].ExpirationDate = selectedValue;
        setExpirationDate(selectedValue);
      }

      if (fieldName === "Notes") {
        entityData[rowIndex].Notes = selectedValue?.trim();
        setNotes(selectedValue?.trim());
      }
      entityData[0].EntityName === "" || entityData[0].StateID === ""
        ? setHasEntity(false)
        : setHasEntity(true);
    }
  };

  const handleEdit = (row) => {
    setEditState(true);
    setEntityExist(false);
    setChanged(false);
    setCheckState(row.isActive);
    setState(states.filter((item) => item.label === row.state)[0]);
    setlicensetype(
      licensetypes.filter((item) => item.value === row.licenseTypeId)[0]
    );
    setDRLP1licensetype(
      licensetypes.filter((item) => item.label === row.drlp1licenseType)[0]
    );
    entityData[0].entityId = row.entityId;
    entityData[0].EntityName = row.entityName;
    entityData[0].EntityEIN = row.entityEin;
    entityData[0].LicenseNumber = row.licenseNumber;
    entityData[0].StateID = row.stateId;
    entityData[0].LicenseTypeID = row.licenseTypeId;
    entityData[0].DRLP1 = row.drlp1;
    setdrlp1Value(row.drlp1);
    entityData[0].DRLP1LicenseType = row.drlp1licenseType;
    entityData[0].DRLP1ExpDate = row.drlp1expDate;
    setDRLExpDate(row.drlp1expDate);
    entityData[0].DRLP1LicenseNumber = row.drlp1licenseNumber;
    setDrlp1licenseNumber(row.drlp1licenseNumber);
    entityData[0].DisregardedForTax = row.disregardedForTax;
    setDisregardedForTax(row.disregardedForTax);
    entityData[0].Comments = row.comments;
    setComments(row.comments);
    entityData[0].ExpirationDate = row.expirationDate;
    setExpirationDate(row.expirationDate);
    entityData[0].Notes = row.notes;
    setNotes(row.notes);
    entityData[0].createdBy = row.createdBy;
    entityData[0].createdOn = row.createdOn;
    entityData[0].updatedBy = userAccount.username;
    entityData[0].updatedOn = new Date().toLocaleDateString();
    entityData[0].isActive = row.isActive;
    entityData[0].usedInMexico = row.usedInMexico;
  };
  //Update entity function

  const Update = () => {
    if (changed) {
      if (!entityExist) {
        if (entityData[0].EntityName !== "" && entityData[0].StateID !== 0) {
          updateEntity(entityData[0].entityId, entityData)
            .then((res) => {
              if (res.data === "duplicate") {
                toast.fire(
                  "Updating Entity failed",
                  "Entity already exist",
                  "error"
                );
                setopenModal(false);
              } else if (res.status === 201) {
                queryClient.invalidateQueries("Entity");
                toast.fire("Success", "Entity Updated Successfully", "success");
                updateEntityList();
                rowIsExpanded(false);
                Cancel();
                setopenModal(false);
              } else {
                toast.fire(
                  "Updating Entity failed",
                  "Server Error: Cannot update Entity",
                  "error"
                );
              }
            })
            .catch((err) => {
              toast.fire("Failed", "Failed to Update Entity", "error");
            });
        } else {
          toast.fire(
            "Saving Failed",
            "All required fields must be filled!",
            "error"
          );
        }
      } else {
        toast.fire(
          "Saving Failed",
          "Licensed Entity Data Already Exist",
          "error"
        );
        setopenModal(false);
      }
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setopenModal(false);
    }
  };

  const Cancel = () => {
    setEditState(false);
    setEdit(false);
    CollapseAll();
    rowIsExpanded(false);
  };
  const EditRow = (row) => {
    const updatedData = EntityData.map((item) => {
      if (item.entityId === row.entityId) {
        item.editRow = true;
        item.expandRow = true;
      } else {
        item.editRow = false;
        item.expandRow = false;
      }
      return { ...item };
    });

    setentitydataForEdit(updatedData);
  };

  const ExpandRow = (row) => {
    let drlp1LicenseType = "";
    setShow(!show);
    const updatedData = EntityData.map((item) => {
      if (item.entityId === row.entityId) item.expandRow = !item.expandRow;
      return { ...item };
    });
    drlp1LicenseType = licensetypes.filter(
      (item) => item.label.toString() === row.drlp1licenseType
    )[0];
    setlicensetype(
      licensetypes.filter((item) => item.value === row.licenseTypeId)[0]
    );
    setentitydataForEdit(updatedData);
    setDRLP1licensetype(drlp1LicenseType);
  };
  const CollapseAll = () => {
    const updatedData = EntityData.map((item) => {
      item.expandRow = false;
      item.editRow = false;

      return { ...item };
    });
    setentitydataForEdit(updatedData);
  };

  const columns = [
    {
      name: "Licensed Entity Name",
      selector: "entityName",
      sortable: true,
      align: "text-left",
      cell: (row) => {
        return row.editRow ? (
          <div className="w-full">
            <label className="block font-medium text-gray-700 mb-2 whitespace-pre">
              <span className="text-red-500">*</span> Licensed Entity Name:
            </label>
            <div className="">
              <TextInput
                defaultValue={row.entityName}
                onChange={(e) =>
                  handleEditEntity("EditEntity", "EntityName", e.target.value)
                }
              />
            </div>
          </div>
        ) : (
          <div className="w-full">
            <div className="text-quinary font-bold font-sans text-base uppercase">
              {row.entityName}
            </div>
          </div>
        );
      },
    },
    {
      name: "State",
      selector: "state",
      sortable: true,
      align: "left",
      //center: true,
      headerStyle: {
        whiteSpace: "nowrap",
      },
      cell: (row) => {
        row.state = row.state
          ? row.state
          : row.stateId
          ? states.filter((x) => x.value === row.stateId)[0]?.label
          : "";
        return row.editRow ? (
          <div className="flex-justify-center w-full">
            <label className="block font-medium text-gray-700 mb-2  whitespace-pre">
              <span className="text-red-500">*</span> State:
            </label>
            <div className="">
              <SelectInput
                options={states}
                defaultValue={{ label: row.state, value: row.stateId }}
                onChange={(selectedOptions) => {
                  setState(selectedOptions);
                  handleEditEntity(
                    "EditEntity",
                    "StateId",
                    selectedOptions == null ? "" : selectedOptions.value,
                    selectedOptions == null ? "" : selectedOptions.label
                  );
                }}
              />
            </div>
          </div>
        ) : (
          <div className="flex justify-center">{row.state}</div>
        );
      },
    },
    {
      name: "Entity EIN",
      selector: "entityEin",
      sortable: true,
      align: "left",
      //center: true,
      cell: (row) => {
        return row.editRow ? (
          <div className="flex-justify-center">
            <label className="block font-medium text-gray-700 mb-2">
              Entity EIN:
            </label>
            <div className="">
              <TextInput
                defaultValue={row.entityEin}
                onChange={(e) =>
                  handleEditEntity("EditEntity", "EntityEIN", e.target.value)
                }
              />
            </div>
          </div>
        ) : (
          <div className="flex justify-center">{row.entityEin}</div>
        );
      },
    },
    {
      name: "License Number",
      selector: "licenseNumber",
      sortable: true,
      align: "left",
      //center: true,
      cell: (row) => {
        return row.editRow ? (
          <div className="flex-justify-start">
            <label className="block font-medium text-gray-700 mb-2 whitespace-pre">
              License Number:
            </label>
            <div className="item-start">
              <TextInput
                defaultValue={row.licenseNumber}
                onChange={(e) =>
                  handleEditEntity(
                    "EditEntity",
                    "LicenseNumber",
                    e.target.value
                  )
                }
              />
            </div>
          </div>
        ) : (
          <div className="w-full text-left">{row.licenseNumber}</div>
        );
      },
    },
    {
      name: "Expiration Date",
      selector: "expirationDate",
      sortable: true,
      align: "left",
      //center: true,
      type: "date",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      cell: (row) => {
        return row.editRow ? (
          <div className="flex-justify-start">
            <label className="block font-medium text-gray-700 mb-2 whitespace-pre">
              Expiration Date:
            </label>
            <div className="w-28">
              <TextInput
                placeholder="Expiration Date"
                value={expirationDate === "" ? null : expirationDate}
                type="date"
                onChange={(e) => {
                  handleEditEntity(
                    "EditEntity",
                    "ExpirationDate",
                    e.target.value
                  );
                }}
              />
            </div>
          </div>
        ) : (
          <div className="w-full text-left">
            {new Date(row.expirationDate).toLocaleDateString() ===
            "Invalid Date"
              ? ""
              : new Date(row.expirationDate).toLocaleDateString("en-US", {
                  timeZone: "UTC",
                })}
          </div>
        );
      },

      headerStyle: {
        color: "#203A75",
        whiteSpace: "pre",
      },
    },
    {
      name: "Created By",
      selector: "createdBy",
      sortable: true,
      align: "left",
      //center: true,
    },
    {
      name: "Created Date",
      selector: "createdOn",
      sortable: true,
      align: "left",
      //center: true,
      type: "date",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      cell: (row) => {
        return (
          <div className="w-full">
            {row.createdOn ? new Date(row.createdOn).toLocaleDateString() : ""}
          </div>
        );
      },
    },
    {
      name: "Modified By",
      selector: "updatedBy",
      sortable: true,
      align: "left",
      //center: true,
    },
    {
      name: "Modified Date",
      selector: "updatedOn",
      sortable: true,
      align: "left",
      //center: true,
      type: "date",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      cell: (row) => {
        return (
          <div className="w-full">
            {row.updatedOn ? new Date(row.updatedOn).toLocaleDateString() : ""}
          </div>
        );
      },
    },
    {
      name: "Status",
      selector: "isActive",
      sortable: true,
      align: "left",
      //center: true,
      cell: (row) => {
        return row.editRow ? (
          <div className="flex justify-start place-items-center  space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-left space-x-1 cursor-pointer"
              checked={checkState}
              onClick={(e) => {
                handleCheckBox(e.target.checked);
              }}
            />
            <label
              className="cursor-pointer text-green-600 text-xs whitespace-nowrap sm:whitespace-normal"
              name="Status"
            >
              {checkState ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans text-left mr-4 text-xs ">
              {row.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      name: "Action/s",
      center: true,
      cell: (row) => {
        return (
          <div className="lg:flex lg:flex-row lg:flex-col justify-start items-center ">
            {row.editRow ? (
              <div className="xl:flex xl:flex-row justify-start items-center sm:flex sm:flex-col lg:flex-col ">
                <ButtonForModal
                  className={`flex shadow-md lg:text-center font-semibold text-white  gap-x-1 rounded-full  bg-senary hover:bg-senary  px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
                               ${
                                 !hasEntity || !changed
                                   ? "opacity-50"
                                   : "opactiy-100"
                               }`}
                  disabled={!hasEntity || !changed}
                  onClick={() => {
                    if (hasEntity) {
                      setopenModal(true);
                    }
                  }}
                >
                  <CheckCircleIcon className="h-4 w-4" />
                  Save
                </ButtonForModal>

                <ButtonForModal
                  className=" flex lg:text-center shadow-md font-semibold text-white rounded-full bg-octonary hover:bg-octonary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70"
                  isDisabled={false}
                  onClick={() => {
                    Cancel();
                  }}
                >
                  <XCircleIcon className="h-4 w-4" />
                  Cancel
                </ButtonForModal>
              </div>
            ) : (
              <div
                className={` flex flex-row flex-col justify-center items-center  ${
                  edit ? "opacity-50" : "opacity-100"
                }`}
              >
                {row.expandRow ? (
                  <HideButton
                    className=""
                    buttonText="Hide"
                    isDisabled={(show, edit)}
                    onClick={() => {
                      ExpandRow(row);
                      rowIsExpanded(false);
                    }}
                  />
                ) : (
                  <div className="grid grid-rows-2 gap-2 ">
                    <ButtonForModal
                      className={
                        (show || selectedRows.length > 0
                          ? "opacity-50 cursor-pointer"
                          : "") +
                        " border  text-white bg-quinary border-quinary hover:bg-hquinary  "
                      }
                      isDisabled={
                        show || selectedRows.length > 0 || edit ? true : false
                      }
                      onClick={() => {
                        ExpandRow(row);
                        rowIsExpanded(true);
                      }}
                    >
                      <EyeIcon className="h-4 w-4" />
                      Show
                    </ButtonForModal>
                    {userPermissions.includes(editPermission) ? (
                      <ButtonForModal
                        className={
                          (show || selectedRows.length > 0
                            ? "opacity-50 cursor-pointer"
                            : "") +
                          " border text-white bg-quaternary border-quaternary hover:bg-hquaternary"
                        }
                        isDisabled={
                          show || selectedRows.length > 0 || edit ? true : false
                        }
                        onClick={() => {
                          // setDRLP1licensetype(licen);
                          setEdit(true);
                          EditRow(row);
                          handleEdit(row);
                        }}
                      >
                        <PencilSquareIcon className="h-4 w-4" />
                        Edit
                      </ButtonForModal>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const filteredColumns = editState
    ? columns.filter(
        (column) =>
          column.name !== "Created By" &&
          column.name !== "Created Date" &&
          column.name !== "Modified By" &&
          column.name !== "Modified Date"
      )
    : columns;

  return (
    <div>
      {userPermissions.includes(deletePermission) ? (
        <div className="text-secondary italic text-xs3 my-2">
          <p className="font-bold italic inline-block mr-1">Note:</p>
          <span>Tick the box to deactivate some data.</span>
        </div>
      ) : (
        <div className="mb-4"></div>
      )}
      <ConfirmBoxModal
        ModalTitle="Update Entity"
        qConfirmation=" Are you sure you want to update this?"
        isOpen={openModal}
        onClose={() => setopenModal(false)}
        onClickFunction={() => {
          setEditState(false);
          Update();
        }}
      />
      <div className="mb-4 content-center">
        <Table
          selectableRows={
            userPermissions.includes(deletePermission)
              ? show || edit
                ? false
                : true
              : false
          }
          selectedRows={selectedRows}
          handleBulkDelete={handleBulkDelete}
          setOpenModal={setOpenModal}
          setIsBulkSelected={setIsBulkSelected}
          onSelectedRowsChange={handleSelectedRowsChange}
          columns={filteredColumns}
          data={
            // officeBrandFilteredData.length > 0
            //   ? officeBrandFilteredData
            //  :
            edit ? entitydataForEdit : EntityData
          }
          expandableRows
          expandableRowsComponent={(row) =>
            edit ? (
              <EntityExpandedRow
                data={row.data}
                setEdit={setEdit}
                handleEditEntity={handleEditEntity}
                dRLP1licensetype={dRLP1licensetype}
                setDRLP1licensetype={setDRLP1licensetype}
                edit={edit}
                CollapseAll={() => CollapseAll()}
                drlExpDate={drlExpDate}
                licensetypes={licensetypes}
                setlicensetype={setlicensetype}
                licensetype={licensetype}
                drlp1Value={drlp1Value}
                drlplicenseNumber={drlplicenseNumber}
                disregardedForTax={disregardedForTax}
                notes={notes}
                comments={comments}
                dRLP1LicenseType={dRLP1LicenseType}
              />
            ) : (
              <EntityExpandedRow
                data={row.data}
                dRLP1licensetype={dRLP1licensetype}
                setDRLP1licensetype={setDRLP1licensetype}
                drlExpDate={drlExpDate}
                licensetypes={licensetypes}
                setlicensetype={setlicensetype}
                licensetype={licensetype}
              />
            )
          }
          expandableRowExpanded={(row) => row.expandRow}
          loading={isLoading}
          expandableRowsComponentProps={entitydataForEdit}
          clearSelectedRows={clearSelectedRows}
          isDeactive={true}
          selectableRowDisabled={(row) => !row.isActive}
          deletePermission={deletePermission}
        />
      </div>
    </div>
  );
};

export default EntityTable;
